// ============================================================
// useSiteConfig / useBranding — lectura compartida de site-config
// Usa la misma queryKey ['site-config'] que el resto de la app,
// así que no genera peticiones duplicadas.
// ============================================================
import { useQuery } from '@tanstack/react-query'
import { api } from '@/utils/api'
import { resolveBranding, type Branding } from '@/utils/brand'

export const SITE_CONFIG_KEY = ['site-config'] as const

export const fetchSiteConfig = () => api.get('/site-config').then(r => r.data)

export function useSiteConfig() {
  return useQuery({ queryKey: SITE_CONFIG_KEY, queryFn: fetchSiteConfig })
}

export function useBranding(): Branding {
  const { data } = useSiteConfig()
  return resolveBranding(data?.branding)
}
